import styled from 'styled-components';
import { Checkbox } from '../../../components_v2/filterList/style/Style';
import { DefaultText } from '../../../styles/global/css/GlobalText';
import {
	GreySidely,
	SidelyBlack,
	SurfaceColor
} from '../../../styles/global/css/Utils';

export const ModalNoClose = styled.div`
  .close {
    display: none;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`;

export const TopContainer = styled.div<{ width: number }>`
  display: flex;
  justify-content: space-between;
  width: ${p => p.width}px;
  align-items: center;
`;


export const Hiden = styled.div`
  	.show-on-hover {
    	display: none;
   	}

    &:hover {
    	.show-on-hover {
      		display: block;
     	}
   	}
`;

export const LegendContainer = styled.div`
  display: flex;
  flex-flow: column;
  gap: 5px;
  background: ${SurfaceColor};
  box-shadow: 0px 0px 6px color-mix(in oklab, ${SidelyBlack} 25%, transparent);
  border-radius: 5px;
  padding: 10px;
  width: fit-content;
  text-transform: capitalize;
`;

export const LegendItem = styled.div<{ desactivated: boolean }>`
  ${({ desactivated }) =>
		desactivated
			? `color: ${GreySidely};`
			: `
  &:hover {
    background-color: color-mix(in oklab, ${SidelyBlack} 20%, transparent);
  }
  `}
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 12px;
  cursor: pointer;
  border-radius: 4px;
  padding: 0 5px;
`;

export const MapCheckbox = styled(Checkbox)`
  flex-shrink: 0;
  margin: 0 15px;
`;
export const MapTextFilters = styled.div`
  ${DefaultText}
  font-size: 11px;
`;
